import React from 'react';
// Components
import Banner from '../../../components/Banner/Banner';
import ProductTable from '../../../components/ProductTable/ProductTable';
import './ITOPET.css';

const ITOPET = () => {
  // Table 1 data (First table)
  const table1Headers = [
    { text: "Özellik", colspan: 1 },
    { text: "1 metre uzunluk (TL)", colspan: 1 },
    { text: "5 metre uzunluk (TL)", colspan: 1 },
    { text: "10 metre uzunluk (TL)", colspan: 1 },
  ];
  
  const table1Rows = [
    [
      { content: "Rs &lt; 70 ohm/sq" },
      { content: "872" },
      { content: "3484" },
      { content: "6420" },
    ],
    [
      { content: "70 &lt; Rs &lt; 140 ohm/sq" },
      { content: "708" },
      { content: "2828" },
      { content: "5224" },
    ],
  ];
  
  // Table 2 data (Second table)
  const table2Headers = [
    { text: "Özellik", colspan: 1 },
    { text: "Uzunluk", colspan: 1 },
    { text: "Fiyat (TL)", colspan: 1 },
  ];
  
  const table2Rows = [
    [
      { content: "Rs &lt; 50 ohm/sq" },
      { content: "5 cm x 5 cm" },
      { content: "136 TL (+ KDV)" },
    ],
    [
      { content: "Rs &lt; 50 ohm/sq" },
      { content: "10 cm x 10 cm" },
      { content: "512 TL (+ KDV)" },
    ],
    [
      { content: "Rs &lt; 50 ohm/sq" },
      { content: "10 cm x 20 cm" },
      { content: "952 TL (+ KDV)" },
    ],
    [
      { content: "Rs &lt; 50 ohm/sq" },
      { content: "20 cm x 20 cm" },
      { content: "1836 TL (+ KDV)" },
    ],
  ];

  return (
    <div className="itopet-page">
      {/* Main Content */}

      {/* Banner */}
      <Banner 
        title="ITO kaplamalı PET ve PC" 
        backgroundImage={require('../../../assets/images/inner-banner.jpg')} 
      />

      {/* Page Content */}
      <section className="itopet-content">
        <div className="container content-container">
          {/* Section 1: First Data Table */}
          <div className="table-section">
            <ProductTable 
              headers={table1Headers}
              rows={table1Rows}
              className="table-1"
            />
          </div>

          {/* Section 2: Subheading */}
          <div className="subheading">
            <h4>ITO kaplamalı PET</h4>
          </div>

          {/* Section 3: Second Data Table */}
          <div className="table-section">
            <ProductTable 
              headers={table2Headers}
              rows={table2Rows}
              className="table-2"
            />
          </div>

          {/* Section 4: Image */}
          <div className="image-section">
            <img 
              src={require('../../../assets/images/pasted-image-1.jpg')} 
              alt="ITO kaplamalı PET ve PC örneği" 
              className="img-fluid"
            />
          </div>

          {/* Section 5: Note */}
          <div className="note">
            <h5>
              100 m den fazla sipariş vermek isterseniz, özel fiyatlar için lütfen bizimle iletişime geçiniz
            </h5>
          </div>
        </div>
      </section>

    </div>
  );
};

export default ITOPET;
